import LotteryFFCManager from "../ffcLottery/LotteryFFCManager";
import LotteryFFCItem from "../ffcLottery/LotteryFFCItem";
import LotteryCenterPrefab from "../LotteryCenterPrefab";
import O1HD from "../../../../engines/gameEngine";
import gameConfig from "../../../../engines/configs/gameConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;
/**
 *
 * 分分彩预制体
 */
@ccclass
export default class LotteryFFCSimplePrefab extends cc.Component {

    @property({type:cc.Prefab,displayName:"分分彩历史预制体"})
    ffcHistoryPrefab : cc.Prefab = null;
    @property({type:cc.Label,displayName:"上一次的开奖结果"})
    lbBeforeResult : cc.Label = null;
    @property({type:cc.Label,displayName:"倒计时"})
    lbDownTown : cc.Label = null;
    @property({type:cc.Label,displayName:"下单号码"})
    ebLotteryNum : cc.Label[] = [];
    @property({type:cc.Node,displayName:"下注按钮"})
    btnBet : cc.Node = null;

    private mLotteryFFCManager : LotteryFFCManager;
    //当前选择下标
    private currInputChooseIndex : number = 0;

    onLoad () {}

    start () {

    }

    bindData( lotteryFFCManager : LotteryFFCManager ){
        this.mLotteryFFCManager = lotteryFFCManager;
        // this.initData();
    }

    initData(){
        //上一期的开奖号码
        this._setBeforeResult();
        //设置开奖倒计时
        this.lbDownTown.string = `${60 - new Date().getSeconds()}`;
        this.schedule(()=>{
            this._setCutDown();
        },1);

        //本期购买号码
        let purchaseNumStr : string = null;
        for ( let betNum of this.mLotteryFFCManager.currBetLotteryNumber ) {
            if ( !purchaseNumStr ) {
                purchaseNumStr = `${betNum}`;
            }else{
                purchaseNumStr += `,${betNum}`;
            }
        }
        //当期已经买过，下注按钮无效
        if( this.mLotteryFFCManager.currBetLotteryNumber.length > 0 ){
            this.btnBet.getComponent(cc.Button).interactable = false;
        }
    }

    /**
     * 设置数值
     * @param e
     * @param buttonNum
     */
    onBtnSetNum( e , buttonNum : string ){
        O1HD.getManagers().soundMgr.playSound("caipiaodianxuanhao");
        this.ebLotteryNum[this.currInputChooseIndex++].string = `${buttonNum}`;
        if ( this.currInputChooseIndex == 4 ) {
            this.node.getChildByName("bottomLayout").active = false;
            this.btnBet.active = true;
        }
    }

    /**
     * 设置上次开奖结果
     * @private
     */
    private _setBeforeResult(){
        if ( this.mLotteryFFCManager.historyResultArray.length == 0 ) {
            this.lbBeforeResult.node.parent.active = false;
        }else{
            this.lbBeforeResult.node.parent.active = true;
            this.lbBeforeResult.string = `${this.mLotteryFFCManager.historyResultArray[this.mLotteryFFCManager.historyResultArray.length - 1 ] }`;
        }
    }

    /**
     *
     * @private
     */
    _setCutDown(){
        let cutDownNum = Number(this.lbDownTown.string);
        if ( cutDownNum == 1 ) {
            this._setBeforeResult();
            this.lbDownTown.string = `${60}`;
        }else{
            this.lbDownTown.string = `${cutDownNum - 1 }`;
        }
    }

    onBtnCommit(){
        if ( this.currInputChooseIndex == 4 ) {
            if(O1HD.getServices().userSrv.getCoins()>= gameConfig.LOTTERY_FFC_BET_COINS){
                // 下注
                let lotteryNumArray : number[] = [];
                for ( let item of this.ebLotteryNum ) {
                    lotteryNumArray.push( Number(item.string) );
                }
                this.mLotteryFFCManager.betOne( lotteryNumArray );
                O1HD.getServices().userSrv.setCoins( -gameConfig.LOTTERY_FFC_BET_COINS , true);
                O1HD.getModules().uiControlModule.showDialogBox("提示","恭喜你下注成功，结果将在24小时后自动公布",false);
                this.node.parent.getChildByName("btnNode").active = true;
                this.node.removeFromParent();
                this.node.destroy();
            }else{
                O1HD.getModules().uiControlModule.showMessageBox("钱不够");
                
                NormalGameManager._instance.openBankPage();
            }
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("请选择四个号码");
        }

    }

    /**
     * 直接退出
     */
    onBtnExit(){
        this.node.parent.getChildByName("btnNode").active = true;
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 打开开奖历史
     */
    onBtnOpenHistory(){
        let ffcHistoryNode = cc.instantiate( this.ffcHistoryPrefab );
        this.node.addChild( ffcHistoryNode );
    }

    /**
     * 下注
     */
    onBtnBet(){
        // this.mLotteryFFCManager.betOne( Number( this.ebLotteryNum.string) );
        // this.btnBet.getComponent(cc.Button).interactable = false;
        // this.lbHasBet.string = `${this.ebLotteryNum.string}`;
    }

    /**
     * 机选号码
     */
    onBtnRandom(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let randomNum = Math.floor( Math.random() * 10 );
        // this.ebLotteryNum.string = `${randomNum}`;
    }

    /**
     * 输出完成后
     */
    onEbEnd(e){
        // if ( isNaN( parseInt( this.ebLotteryNum.string ) )  ) {
        //     O1HD.getModules().uiControlModule.showMessageBox("请输入数字" , this.node );
        //     // this.ebLotteryNum.string = `1`;
        //     return;
        // }
        //
        // if ( parseInt( this.ebLotteryNum.string ) <= 0 ){
        //     O1HD.getModules().uiControlModule.showMessageBox("最小为1" , this.node );
        //     // this.ebLotteryNum.string = `1`;
        //     return;
        // }
        //
        // if ( parseInt( this.ebLotteryNum.string ) > 32 ){
        //     O1HD.getModules().uiControlModule.showMessageBox("最大为32" , this.node );
        //     this.ebLotteryNum.string = `32`;
        //     return;
        // }

    }
}
